import React from "react";
import Admit from "./admit";
import VisionMission from "./VisionMission";
import AboutWhy from "./AboutWhy";
import "./about.css";
import OurTeam from "./OurTeam";
import FraudWarning from "./FraudWarning"; 

function AboutPage() {
  return (
    <>
      <div className="aboutpage-no-gap">
        <Admit />
        <VisionMission />
        <AboutWhy />

        {/* OUR STORY CARD */}
        <section className="story-section">
          <div className="story-card">
            {/* LEFT – CONTENT (70%) */}
            <div className="story-content">
              <h2 className="story-title">Our Value</h2>
              <span className="story-underline"></span>

              <p>
             We build long-term relationships through clear communication and reliable solutions.
              </p>

              <p>
                From humble beginnings, we expanded across life, health, and
                general insurance, always guided by trust, transparency, and
                long-term relationships.
              </p>

              <p>
                Today, we proudly serve a diverse community with tailored
                insurance solutions, expert advice, and unwavering support —
                staying true to our founding values while continuously evolving
                to meet modern needs.
              </p>
            </div>

            {/* RIGHT – IMAGE (30%) */}
            <div className="story-image">
              <img src="/values.jpg" alt="Our Values" />
            </div>
          </div>
        </section>

        <OurTeam />
      </div>

  <FraudWarning />
    </>
  );
}

export default AboutPage;
